import { Component, DOCUMENT, Inject, Injector, OnInit } from '@angular/core';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';

import { NgClass } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { AppConsts } from '@shared/AppConsts';
import { OffcanvasDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/offcanvas.directive';
import { ToggleDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/toggle.directive';
import { FooterComponent } from '../../footer.component';
import { SideBarMenuComponent } from '../../nav/side-bar-menu.component';
import { ScrollTopComponent } from '../../scroll-top.component';
import { TopBarComponent } from '../../topbar.component';
import { DefaultBrandComponent } from './default-brand.component';

@Component({
    templateUrl: './default-layout.component.html',
    selector: 'default-layout',
    imports: [RouterLink, ToggleDirective, OffcanvasDirective, DefaultBrandComponent, SideBarMenuComponent, TopBarComponent, NgClass, RouterOutlet, FooterComponent, ScrollTopComponent]
})
export class DefaultLayoutComponent extends ThemesLayoutBaseComponent implements OnInit {

    menuCanvasOptions: OffcanvasOptions = {
        baseClass: 'kt-aside',
        overlay: true,
        closeBy: 'kt_aside_close_btn',
        toggleBy: {
            target: 'kt_aside_mobile_toggler',
            state: 'kt-header-mobile__toolbar-toggler--active'
        }
    };

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    constructor(
        injector: Injector,
        _dateTimeService: DateTimeService,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector, _dateTimeService);
    }

    ngOnInit() {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    }
}
